import { useState } from 'react';
import { api } from '../../api/client';
import { Alert, Button } from '../../ui';

/**
 * CR-56 P3 — "Download PDF" on A-45 and R-27.
 *
 * The bytes are fetched through the API, not linked to: a plain `<a href>` cannot carry the
 * `x-portal` header the route scopes on, so `api.download` does the request and the browser is
 * handed the result as a file — the same way R-06 downloads a consignment invoice. The PDF is the
 * API's document and says on its face that it is not a tax invoice (D57); nothing here edits it.
 *
 * Words come in as props for the same reason `PurchaseInvoiceBody`'s do: A-45 is Miraki's own console
 * (literals) and R-27 is a trade customer's screen (`t()`, D47).
 */
export function DownloadPdfButton({ path, fallbackName, label, failed }: {
  path: string; fallbackName: string; label: string; failed: string;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);

  const save = async () => {
    setBusy(true);
    setError(false);
    try {
      const { blob, fileName } = await api.download(path);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName ?? fallbackName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      // After the click has handed the blob to the download, not before.
      setTimeout(() => URL.revokeObjectURL(url), 0);
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button tone="ghost" size="sm" disabled={busy} onClick={() => { void save(); }}>{label}</Button>
      {error ? <Alert tone="stop">{failed}</Alert> : null}
    </>
  );
}
